import { useMemo } from 'react';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { readOverride } from 'shared/feature-flags/feature-flag-storage';
import { FEATURE_FLAGS, FeatureFlagName } from 'shared/feature-flags/flags';
import { resolveFeatureFlag } from 'shared/feature-flags/resolve-feature-flag';

/**
 * Значение фиче-флага для текущего пользователя.
 *
 * Override читается на каждый рендер: его пишут `?flow=` и вкладка настроек «Интерфейс»,
 * после чего экран должен перерисоваться на смене пользователя или навигации.
 */
export const useFeatureFlag = (name: FeatureFlagName): boolean => {
  const { user } = useAuth();

  return useMemo(
    () =>
      resolveFeatureFlag({
        override: readOverride(name),
        userCreatedAt: user?.created_at,
        since: FEATURE_FLAGS[name].since,
      }),
    [name, user],
  );
};
